import classes from "./Header.module.scss";
import divider from "./../../../../../assets/images/divider.svg";
import { useSelector } from "react-redux";

const Header = () => {
  const payload = useSelector((state) => state.purchase);

  return (
    <header className={classes.HeaderContent}>
      <div
        className={
          payload.purchase.step === "InvoiceData"
            ? classes.HeaderSelected
            : classes.HeaderDefault
        }
      >
        dados da fatura
      </div>
      <img className={classes.ImageDivider} src={divider} alt="" />
      <div
        className={
          payload.purchase.step === "InvoiceData"
            ? classes.HeaderDefault
            : classes.HeaderSelected
        }
      >
        pagamento
      </div>
    </header>
  );
};
export default Header;
